var chunkMapping = {
	"apps_console-core_src_Constants_Screens_constants_tsx": [
		42609
	],
	"__federation_expose_Components": [
		97267,
		25477,
		20226,
		38791,
		29281,
		79994,
		99946,
		85777,
		16283,
		23036
	]
};
var idToExternalAndNameMapping = {
	"16283": [
		"default",
		"./Constants",
		2708
	],
	"20226": [
		"default",
		"./Constants",
		30849
	],
	"23036": [
		"default",
		"./Constants",
		78434
	],
	"25477": [
		"default",
		"./Constants",
		1473
	],
	"29281": [
		"default",
		"./Constants",
		67178
	],
	"38791": [
		"default",
		"./Constants",
		99013
	],
	"42609": [
		"default",
		"./State",
		1473
	],
	"79994": [
		"default",
		"./Constants",
		4904
	],
	"85777": [
		"default",
		"./Constants",
		12011
	],
	"97267": [
		"default",
		"./Constants",
		27764
	],
	"99946": [
		"default",
		"./Constants",
		48758
	]
};
var idToRemoteMap = {
	"16283": [
		{
			"externalType": "script",
			"name": "dxpMonitoring",
			"externalModuleId": 2708
		}
	],
	"20226": [
		{
			"externalType": "script",
			"name": "dxpArtificialIntelligence",
			"externalModuleId": 30849
		}
	],
	"23036": [
		{
			"externalType": "script",
			"name": "dxpOptimization",
			"externalModuleId": 78434
		}
	],
	"25477": [
		{
			"externalType": "script",
			"name": "dxpConsoleCore",
			"externalModuleId": 1473
		}
	],
	"29281": [
		{
			"externalType": "script",
			"name": "dxpConfiguration",
			"externalModuleId": 67178
		}
	],
	"38791": [
		{
			"externalType": "script",
			"name": "dxpComponentService",
			"externalModuleId": 99013
		}
	],
	"42609": [
		{
			"externalType": "script",
			"name": "dxpConsoleCore",
			"externalModuleId": 1473
		}
	],
	"79994": [
		{
			"externalType": "script",
			"name": "dxpCustomerDataPlatform",
			"externalModuleId": 4904
		}
	],
	"85777": [
		{
			"externalType": "script",
			"name": "dxpInstanceManagement",
			"externalModuleId": 12011
		}
	],
	"97267": [
		{
			"externalType": "script",
			"name": "dxpAdministration",
			"externalModuleId": 27764
		}
	],
	"99946": [
		{
			"externalType": "script",
			"name": "dxpDigitalAssetManagement",
			"externalModuleId": 48758
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}